import { compose} from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { showAccessibilityStatementModal } from 'modules/auth/actions/accessibilityStatement';
import AccessibilityStatementButton from './AccessibilityStatementButton';

export default compose(
  connect(null, { showAccessibilityStatementModal }),
  injectIntl,
)(AccessibilityStatementButton);
